// src/components/shared/Map.js
import React, { useEffect, useRef } from 'react';

const Map = ({ addresses, zoom = 10, supplierPin = null, jobSitePin = null, center = null }) => {
const mapRef = useRef(null);

  useEffect(() => {

    if(!center) center = addresses[0];

    const loadMap = () => {
      const map = new window.google.maps.Map(mapRef.current, {
        zoom: zoom,
        center: center,  // Center map on the first address
      });

      // Define the info window
      const infoWindow = new window.google.maps.InfoWindow();

      // Add markers for each address
      addresses.forEach((address, index) => {       
        const marker = new window.google.maps.Marker({
          position: { lat: address.lat, lng: address.lng },
          map: map,
          gmpClickable: true,
          title: address.title,
          icon: address.isSupplier ? supplierPin : jobSitePin,  // Use custom pin if provided
        });

        let infoWindowContent = '';
        if (address.isJob) {
          // If it's a job, show job-related fields
          infoWindowContent = `
            <div style="padding: 10px; font-size: 14px; color: #000">
              <h4 style="margin: 0;">${address.title}</h4>
              <p><b>Estimate ID:</b> ${address.estimateId}</p>
              <p><b>City:</b> ${address.city}</p>
              <p><b>Services:</b> ${address.services.map(service => service.name).join(', ')}</p>
              <p><b>Total Area:</b> ${address.totalArea} sqft</p>
              <p><b>Start Date:</b> ${address.startDate}</p>
              <p><b>End Date:</b> ${address.endDate}</p>
            </div>
          `;
        } else if (address.isSupplier) {
          // If it's a supplier, show supplier-related fields
          infoWindowContent = `
            <div style="padding: 10px; font-size: 14px; color: #000">
              <h4 style="margin: 0;">${address.title}</h4>
              <p><b>Distance:</b> ${address.distance} miles</p>
              <p><b>Products:</b> ${address.products.join(', ')}</p>
            </div>
          `;
        }else{
          infoWindowContent = `
            <div style="padding: 10px; font-size: 14px; color: #000">
              <h4 style="margin: 0;">${address.title}</h4>
            </div>
          `;
        }

         // Add click listener to open info window on marker click
         marker.addListener('click', () => {
          infoWindow.setContent(infoWindowContent);
          infoWindow.open(map, marker);
        });

      });
    };

    if (!window.google) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
      script.async = true;
      script.onload = loadMap;
      document.body.appendChild(script);
    } else {
      loadMap();
    }
  }, [addresses, zoom, supplierPin, jobSitePin]);


  return <div ref={mapRef} style={{ width: '100%', height: '400px' }} />;
};

export default Map;
